module.exports = "js/webpack/9b2205bc5b0cad9dfc56d407c90dfa0c.svg";